import Container from 'components/helpers/Container';
import { MissingDataSource } from 'components/helpers/EditingHelpText';
import { classnames } from 'tailwindcss-classnames';
import CalloutCardCard, { CalloutCardItem } from '../../../helpers/Cards/calloutcard-card';

type CalloutCardProps = CalloutCardItem & {
  isSingleColumn?: boolean;
};

const CalloutCard = (props: CalloutCardProps): JSX.Element => {
  const { fields, isSingleColumn } = props;
  if (!fields) {
    return <MissingDataSource />;
  }
  return (
    <Container
      size="standard"
      className={classnames('callout-card-container')}
      dataComponent="authorable/general/calloutcard"
    >
      <CalloutCardCard promotedPage={props} isSingleCard={isSingleColumn} />
    </Container>
  );
};

export default CalloutCard;
